<app-header
  icon="fas fa-link"
  text="Gast-Links"
  sub="Ihre aktiven Gast-Links, über welche externe Nutzer:innen auf interne Ansichten und interne Daten zugreifen können."></app-header>
<p-divider />

@if (store.withGuestLinks(); as bookmarks) {
  <p-table #linkTable [globalFilterFields]="['title']" [value]="bookmarks">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [searchWord]="searchWord"
        (clearTable)="clear(linkTable)"
        (search)="
          linkTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Name</th>
        <th>Themenbereich</th>
        <th>Ablaufdatum</th>
        <th>PIN</th>
        <th>Erstellt von</th>
        <th>Aktionen</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td>
          <p-tag severity="secondary">
            <span class="flex gap-2 align-items-center">
              <i
                [class]="
                  value.guestLink?.enabled
                    ? 'fas fa-check-circle'
                    : 'fas fa-xmark-circle'
                "></i>
              @if (value.guestLink?.enabled) {
                aktiv
              } @else {
                inaktiv
              }
            </span>
          </p-tag>
        </td>
        <td>
          <span class="flex gap-3 align-items-center">
            <strong class="flex align-items-center gap-3">
              {{ value.title }}</strong
            >
          </span>
        </td>
        <td>{{ getCategory(value) }}</td>
        <td>
          @if (value.guestLink?.expiresAt; as expiresAt) {
            <p-tag [severity]="isExpired(expiresAt) ? 'warning' : 'success'">
              <span class="flex gap-2">
                <i
                  class="fas"
                  [class]="
                    isExpired(expiresAt)
                      ? 'fa-calendar-xmark'
                      : 'fa-calendar-check'
                  "></i>
                {{ expiresAt | date: 'dd.MM.yyyy' }}
              </span>
            </p-tag>
          } @else {
            <span class="text-color-secondary font-italic"
              >Kein Ablaufdatum</span
            >
          }
        </td>
        <td>
          @if (value.guestLink && value.guestLink.password) {
            <p-button
              label="kopieren"
              icon="fas fa-copy"
              [text]="true"
              (click)="copyPassword(value.guestLink.password)"
              styleClass="p-button-rounded p-button-xs"
              [raised]="true"
              [rounded]="true"></p-button>
          } @else {
            <span class="text-color-secondary font-italic">ungeschützt</span>
          }
        </td>
        <td>
          @if (
            value.guestLink &&
              userStore.getById(value.guestLink.createdBy).username;
            as username
          ) {
            <i class="fas fa-user-circle"></i> {{ username }}
          } @else {
            <span class="text-color-secondary font-italic">Nicht gefunden</span>
          }
        </td>
        <td class="">
          <div class="flex gap-2">
            <button
              pButton
              pTooltip="Link kopieren"
              tooltipPosition="top"
              [showDelay]="500"
              [outlined]="true"
              class="p-button-rounded p-button-xs"
              (click)="copy(value)"
              [icon]="'fas fa-copy'"></button>
            <button
              pButton
              pTooltip="Ansicht im Gastmodus öffnen"
              tooltipPosition="top"
              [showDelay]="500"
              [outlined]="true"
              class="p-button-rounded p-button-xs"
              (click)="open(value)"
              [icon]="'fas fa-arrow-up-right-from-square'"></button>
            @if (value.guestLink?.enabled) {
              <button
                pTooltip="Link deaktivieren"
                tooltipPosition="top"
                [showDelay]="500"
                pButton
                class="p-button-rounded p-button-xs p-button-warning"
                (click)="toggleGuestLink(value, false)"
                [icon]="'fas fa-link-slash'"></button>
            } @else {
              <button
                pTooltip="Link aktivieren"
                tooltipPosition="top"
                [showDelay]="500"
                pButton
                class="p-button-rounded p-button-xs p-button-success"
                (click)="toggleGuestLink(value, true)"
                [icon]="'fas fa-link'"></button>
            }
            <a
              pButton
              pTooltip="Link bearbeiten"
              tooltipPosition="top"
              [showDelay]="500"
              class="p-button-rounded p-button-xs p-button-primary"
              [icon]="'fas fa-pen'"
              [routerLink]="[{ outlets: { bearbeiten: [value._id] } }]"></a>
            <button
              pButton
              pTooltip="Link löschen"
              tooltipPosition="top"
              [showDelay]="500"
              class="p-button-rounded p-button-xs p-button-danger"
              (click)="removeLink(value)"
              [icon]="'fas fa-trash'"></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine Gast-Links gefunden</span>
    </div>
  </div>
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  styleClass="w-5"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
